import { brand } from '@/theme/themePrimitives';

export function hexToRgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/** Aurora glow tinted by the organization primary hex. Falls back to brand cobalt when invalid or missing. */
export function auroraGlowFromHex(hex?: string): string {
  const validHex = hex && /^#[0-9A-Fa-f]{6}$/.test(hex);
  return validHex ? hexToRgba(hex, 0.3) : hexToRgba(brand[500], 0.2);
}
